import { apiRequest } from "./Api";

export const getCustomersPendings = (params?: any) =>
  apiRequest<any, any>("GET", "costumers/pendings", null, undefined, params);

export const getCustomersPendingsStatisticCardsData = () =>
  apiRequest<any, any>("GET", "costumers/pendings/info-card");

export const getAppointmentPendings = (params?: any) =>
  apiRequest<any, any>("GET", "appointment/pending", null, undefined, params);

export const getAppointmentPendingsStatisticCardsData = () =>
  apiRequest<any, any>("GET", "appointment/pending/info-card");

export const getLeadPendings = (params?: any) =>
  apiRequest<any, any>("GET", "leads/pending", null, undefined, params);

export const getLeadPendingsStatisticCardsData = () =>
  apiRequest<any, any>("GET", "leads/pending/info-card");

export const getDataById = (id: number) =>
  apiRequest<any, any>("GET", `costumers/pendings/${id}`);

export const sendComment = (data?: any) =>
  apiRequest<any, unknown>("POST", "costumers/pendings/store-comment", data);

export const storeNewDocument = (data?: any) =>
  apiRequest<any, unknown>("POST", "costumers/pendings/store-document", data);

export const showPendingDocument = (link?: string) =>
  apiRequest<any, any>("GET", `costumers/pendings/show-file/${link}`);

export const sendFeedback = (data?: any) =>
  apiRequest<any, unknown>("POST", "costumers/pendings/feedback-file", data);

export const makeDonePending = (data?: any) =>
  apiRequest<FormData, any>('POST', 'costumers/pendings/complete', data)

export const makeDoneAppointmentPending = (data?: any) =>
  apiRequest<FormData, any>('POST', 'appointment/pending/update-status', data)

export const makeDoneLeadsPending = (data?: any) =>
  apiRequest<FormData, any>('POST', 'leads/pending/update-status', data)

export const makeDoneOwnPending = (data?: any) =>
  apiRequest<FormData, any>('POST', 'own/pendings/update-status', data)

export const createOwnPending = (data: any) =>
  apiRequest<FormData, any>("POST", "own/pendings/store", data);

export const getOwnPendings = (params?: any) =>
  apiRequest<any, any>("GET", "own/pendings", null, undefined, params);

export const getOwnPendingsStatisticCardsData = () =>
  apiRequest<any, any>("GET", "own/pendings/info-card");

export const getHrPendings = (params?: any) =>
  apiRequest<any, any>("GET", "hr/pendings", null, undefined, params);

export const makeDoneHrPending = (data?: any) =>
  apiRequest<FormData, any>('POST', 'hr/pendings/feedback-absence', data)